// store/modules/guests.js
export default {
  namespaced: true,
  state: {
    numberOfGuest: 1,
    guestCountSetting: {
      fix_guest_count: {
        status: false
      }
    },
    fullName: '',
    isCheckoutFormEmpty: true,
    trackRetakeClick: 0,
    pass: '',
    roomNumber: null,
    paymentAlert: false,
    fincodeToken: null
  },
  mutations: {
    SET_TOKENIZED_CARD(state, payload) {
      state.fincodeToken = payload;
    },

    SET_PAYMENT_ALERT(state, payload) {
      state.paymentAlert = payload;
    },

    TRACK_RETAKE_CLICK(state) {
      state.trackRetakeClick++;
    },

    RESET_RETAKE_CLICK(state) {
      state.trackRetakeClick = 0;
    },

    SAVE_BOOKING_ROOM_NUMBER(state, payload) {
      state.roomNumber = payload
    },

    SAVE_BOOKING_PASS(state, payload) {
      state.pass = payload
    },

    SAVE_NUMBER_OF_GUEST(state, payload) {
      state.numberOfGuest = payload
    },

    SAVE_FULL_NAME(state, payload) {
      state.fullName = payload;
    },
    RESET_RETAKE_CLICK(state) {
      state.trackRetakeClick = 0;
    },

    SET_TOKENIZED_CARD(state, payload) {
      state.fincodeToken = payload;
    },

    SET_PAYMENT_ALERT(state, payload) {
      state.paymentAlert = payload;
    },

    SAVE_NUMBER_OF_GUEST(state, payload) {
      state.numberOfGuest = payload
    },

    GET_GUEST_COUNT_SETTING(state, payload) {
      state.guestCountSetting = { ...payload }
    },

    CHECK_IF_CHECKOUT_FORM_IS_EMPTY(state, payload) {
      state.isCheckoutFormEmpty = payload
    }
  },
  actions: {
     setTokenizedCard({ commit }, payload) {
      commit('SET_TOKENIZED_CARD', payload);
    },

    setPaymentAlert({ commit }, payload) {
      commit('SET_PAYMENT_ALERT', payload);
    },

    trackRetake({ commit }) {
      commit('TRACK_RETAKE_CLICK');
    },

    resetRetake({ commit }) {
      commit('RESET_RETAKE_CLICK');
    },

    saveNumberOfGuest({ commit }, payload) {
      commit('SAVE_NUMBER_OF_GUEST', payload)
    },
    
    saveFullName({ commit }, payload) {
      commit('SAVE_FULL_NAME', payload)
    },

    getGuestCount({ commit }, payload) {
      commit('GET_GUEST_COUNT_SETTING', payload)
    },

    setCheckoutFormEmpty({ commit }, payload) {
      commit('CHECK_IF_CHECKOUT_FORM_IS_EMPTY', payload)
    },

    setBookingPass({ commit }, payload) {
      commit('SAVE_BOOKING_PASS', payload)
    },

    setBookingRoomNo({ commit }, payload) {
      commit('SAVE_BOOKING_ROOM_NUMBER', payload)
    },
  },
  getters: {
    isCheckoutFormEmpty: (state) => {
      return state.isCheckoutFormEmpty;
    },
  }
};
